import React from 'react';
import { PresenceStatus } from '../types';
import { STATUS_DOT_CLASS, STATUS_LABEL } from '../utils/presence';

interface PresenceDotProps {
  status: PresenceStatus;
  /**
   * 위치·크기·테두리. 점이 붙는 자리마다 기하가 달라서(말풍선 아바타 w-3 / 목록 행 w-2 /
   * 즐겨찾기 칩 w-3.5, 테두리는 white·slate-50·chrome-line) 색만 여기서 소유하고
   * 나머지는 호출부가 준다. 기하까지 prop으로 만들면 size×ring 조합 표가 되어 더 복잡해진다.
   */
  className?: string;
  /**
   * 스크린리더용 라벨을 붙인다. 기본은 aria-hidden — 같은 행에 이름과 상태 텍스트가
   * 이미 있는 경우(온라인 탭·멤버 목록)가 대부분이라 점까지 읽으면 중복이 된다.
   */
  labelled?: boolean;
}

/**
 * 접속 상태 점 — 색 판정의 유일한 지점.
 *
 * 예전에는 6곳이 각자 삼항/로컬 맵으로 색을 정해서 오프라인이 slate-300과 slate-500으로
 * 갈리고 라벨이 '자리 비움'/'자리비움'으로 어긋났다. 새 표시 자리를 추가할 때는 반드시
 * 이 컴포넌트를 쓸 것 — 직접 STATUS_DOT_CLASS를 읽으면 같은 일이 반복된다.
 */
export const PresenceDot: React.FC<PresenceDotProps> = ({ status, className = '', labelled }) => (
  <span
    {...(labelled ? { role: 'img', 'aria-label': STATUS_LABEL[status] } : { 'aria-hidden': true })}
    className={`rounded-full ${STATUS_DOT_CLASS[status]} ${className}`}
  />
);
